import type { TestFunction } from 'yup/lib/util/createValidation'

const dateNotInThePast: TestFunction<Date | undefined> = (
  date,
  { createError },
) => {
  if (typeof date !== typeof new Date()) {
    // Given value is not a Date object, should be true since its probably empty string as defaultValue
    return true
  }

  return (date && Date.now() < date.getTime()) ?? createError()
}

export default dateNotInThePast
